const MODULE_PAGES_PREFIX = '/src/onify/citizen/pages/';

// Do not wrap in `typeof import.meta.glob === 'function'`: Vite expands the
// call at transform time but leaves the typeof check, which is false in the
// browser and yields {} — module routes then never register.
const appPageModules = import.meta.glob('/src/onify/citizen/pages/*.vue');
const packagePageModules = import.meta.glob('../../../../../../src/onify/citizen/pages/*.vue');

function normalizeModuleKey(key: string) {
  const match = key.match(/\/src\/onify\/citizen\/pages\/[^/]+\.vue$/);
  return match ? match[0] : key;
}

const pageModules = Object.entries({ ...appPageModules, ...packagePageModules }).reduce(
  (modules, [key, loader]) => {
    modules[normalizeModuleKey(key)] = loader as () => Promise<unknown>;
    return modules;
  },
  {} as Record<string, () => Promise<unknown>>,
);

export function getModulePageComponentKeys() {
  return Object.keys(pageModules);
}

export function getModulePageComponent(componentFile: string) {
  const moduleKey = `${MODULE_PAGES_PREFIX}${componentFile}`;
  return pageModules[moduleKey] ?? null;
}
